import { render } from "./goodsCard.vue?vue&type=template&id=9f809bd0&scoped=true"
import script from "./goodsCard.vue?vue&type=script&lang=js"
export * from "./goodsCard.vue?vue&type=script&lang=js"

import "./goodsCard.vue?vue&type=style&index=0&id=9f809bd0&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f809bd0"]])

export default __exports__